import { render, staticRenderFns } from "./GroupMemberAdd.vue?vue&type=template&id=f64cea06&"
import script from "./GroupMemberAdd.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports